export default "__VITE_ASSET__CoM6FAut__"